import { WorkflowLayoutTriggerEntityModel } from "src/store/models/entity/workflowLayoutTrigger/entity";
import { WorkflowLayoutTriggerHelperModel } from "src/store/models/entity/workflowLayoutTrigger/helper";

export const encooWorkflowLayoutTriggerModels = {
  entity: WorkflowLayoutTriggerEntityModel,
  helper: WorkflowLayoutTriggerHelperModel,
};
